import { defineMessages } from 'react-intl';

export default defineMessages({
  contactUs: {
    id: 'Contact us',
    defaultMessage: 'Contact us',
  },
});
